module.exports = __webpack_public_path__ + "static/img/subscribe.553e158.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subscribe.jpeg
// module id = 6ylN
// module chunks = 222